export default __webpack_public_path__ + "static/media/bg.205d97ef.png";